import { Vue, i18n } from "./vue";
import VueWishlist from "../components/vue/Wishlist/VuePopup.vue";

/**
 * Mounts Vue Wishlist component on elements with class "vue-wishlist"
 *
 * Usage:
 * <button class="vue-wishlist" data-product-id="123" data-in-wishlist="1">
 *     <i class="ico ico-heart"></i>
 * </button>
 *
 * Data attributes:
 * - data-product-id (required): Product ID
 * - data-in-wishlist: "1" or "true" if product is already in a wishlist
 * - data-text: Text to display next to heart icon
 * - data-mobile-text: Text for mobile view
 * - data-orientation: Popup orientation (left, right, bottom, top)
 */

document.addEventListener("click", (event) => {
    const target = event.target?.closest(".vue-wishlist");

    if (!target) return;

    // If not logged in, let Bootstrap handle the login modal
    if (!window.Eshop?.options?.isLogged) {
        return;
    }

    // Prevent default action
    event.preventDefault();
    event.stopPropagation();

    // Check if already mounted
    if (target.dataset.vueMounted === "1") return;

    const productId = target.dataset.productId;
    if (!productId) {
        console.warn("vue-wishlist: missing data-product-id");
        return;
    }

    const props = {
        productId: parseInt(productId, 10),
        inWishlist: target.dataset.inWishlist === "1" || target.dataset.inWishlist === "true",
        text: target.dataset.text || "",
        mobileText: target.dataset.mobileText || "",
        orientation: target.dataset.orientation || "bottom",
        autoOpen: true,
    };

    // Create a wrapper element
    const wrapper = document.createElement("div");
    wrapper.className = "vue-wishlist-wrapper";

    // Insert wrapper before target
    target.parentNode.insertBefore(wrapper, target);

    // Remove original element
    target.remove();

    // Mount Vue component
    new Vue({
        el: wrapper,
        i18n,
        render: (h) => h(VueWishlist, { props }),
    });
});
